// src/config/domains.js
//
// Application-owned vocabulary: the six executive domains.
//
// These domains are a RENDERING concern, not a storage concern. The database
// column intel.understanding_units.domain_key is intentionally unconstrained
// — no CHECK, no foreign key — so renaming, reordering, adding, or splitting
// a domain is a change to THIS FILE plus at most a data UPDATE. It is never a
// migration.
//
// DOMAIN_VERSION exists so that any future remap is auditable: bump it when
// the set or meaning of the keys changes, and the version recorded alongside
// a remap tells you which vocabulary a given row was sorted under.
//
// This module is deliberately not owned by Compass. Overview, Pulse,
// Timeline, Search and Reports all consume it, and none of them should have
// to import from src/modules/compass/ to learn what a domain is.

export const DOMAIN_VERSION = 1;

export const DOMAINS = [
  { key: 'identity',    label: 'Identity',    order: 1 },
  { key: 'leadership',  label: 'Leadership',  order: 2 },
  { key: 'operating',   label: 'Operating',   order: 3 },
  { key: 'performance', label: 'Performance', order: 4 },
  { key: 'knowledge',   label: 'Knowledge',   order: 5 },
  { key: 'strategy',    label: 'Strategy',    order: 6 },
];

export const UNASSIGNED = { key: null, label: 'Unsorted', order: 99 };

// Total function. Any key that is not one of the six above — including null,
// undefined, '', a stale key from a previous DOMAIN_VERSION, or a key a
// future feature has not yet taught this file about — resolves to UNASSIGNED.
// Never throws, never returns undefined.
export function resolveDomain(key) {
  if (!key) return UNASSIGNED;
  const match = DOMAINS.find(d => d.key === key);
  return match || UNASSIGNED;
}
